<div class="p-d-flex p-flex-column">
  <div class="description-text">Ovaj predračun je povezan sa avansnom fakturom {{ brojAvansnog }}. Avansna faktura će automatski biti povezana sa fakturom koju želite da napravite.</div>
  <div class="p-mt-5">Broj računa : {{ brojAvansnog }}</div>
  <div class="p-mt-3">Datum izdavanja : {{ datumIzdavanja | date}}</div>
</div>
